import { ColumnDef } from '@tanstack/react-table';
import CurrencyCell from '../../../components/tables/cellComponents/CurrencyCell';
import { LinkCell } from '../../../components/tables/cellComponents/LinkCell';
import { getDateInUserTimeZone } from '../../dateUtils';
import { formatDateString } from '../../utils';

export const ledgerInstructorPaymentColumns: ColumnDef<any>[] = [
  {
    header: 'Date',
    accessorKey: 'lesson.date',
    cell: ({ getValue }) => formatDateString(getValue<string>())
  },
  {
    header: 'Instructor',
    accessorKey: 'instructor.full_name'
  },
  {
    header: 'Rate',
    accessorKey: 'rate',
    cell: ({ getValue, row }) => <CurrencyCell value={getValue<string | number>()} />
  },
  {
    header: 'Reimbursement',
    accessorKey: 'reimbursement',
    cell: ({ getValue, row }) => <CurrencyCell value={getValue<string | number>()} />
  },
  {
    header: 'Override',
    accessorKey: 'override.override_request',
    cell: ({ getValue, row }) =>
      row.original.override?.override_approved ? getValue<string>() : ''
  },
  {
    header: 'Total',
    accessorKey: 'total',
    cell: ({ getValue, row }) => <CurrencyCell value={getValue<string | number>()} />
  }
];

export const weeklyReportColumns: ColumnDef<any>[] = [
  {
    header: 'Date Start',
    accessorKey: 'start',
    cell: ({ getValue }) => {
      return formatDateString(getValue<string>());
    }
  },
  {
    header: 'Date End',
    accessorKey: 'end',
    cell: ({ getValue }) => {
      const formattedDate = getDateInUserTimeZone(
        getValue<string>().split('T')[0] ?? '',
        'MM/dd/yyyy'
      );
      return formattedDate ?? '';
    }
  },

  {
    header: 'Website Order Revenue',
    accessorKey: 'website_revenue',
    cell: ({ row, getValue }) => (
      <LinkCell
        content={
          '$' +
          `${row.original.website_revenue ? parseFloat(getValue<string>()).toFixed(2) : '0.00'}`
        }
        url={`/admin/orders/orders?location_id=${row.original.location.id}&created_at_gteq_datetime=${row.original.start}&created_at_lteq_datetime=${row.original.end}`}
        underline
      />
    )
  },
  {
    header: 'Invoice Payment Revenue',
    accessorKey: 'invoice_revenue',
    cell: ({ row, getValue }) => (
      <LinkCell
        content={
          '$' +
          `${row.original.invoice_revenue ? parseFloat(getValue<string>()).toFixed(2) : '0.00'}`
        }
        url={`/admin/finance/payments?location_id=${row.original.location.id}&created_at_gteq_datetime=${row.original.start}&created_at_lteq_datetime=${row.original.end}`}
        underline
      />
    )
  },
  {
    header: 'Total Revenue',
    accessorKey: 'total_revenue',
    cell: ({ getValue }) => <CurrencyCell value={getValue<string | number>()} />
  },
  {
    header: 'Refunds',
    accessorKey: 'refunds',
    cell: ({ row, getValue }) => (
      <LinkCell
        content={
          '$' + `${row.original.refunds ? parseFloat(getValue<string>()).toFixed(2) : '0.00'}`
        }
        url={`/admin/orders/refunds?location_id=${row.original.location.id}&created_at_gteq_datetime=${row.original.start}&created_at_lteq_datetime=${row.original.end}`}
        underline
      />
    )
  },
  {
    header: 'Net Revenue',
    accessorKey: 'net_revenue',
    cell: ({ getValue }) => <CurrencyCell value={getValue<string | number>()} />
  },
  {
    header: 'Royalty Fee',
    accessorKey: 'royalty_fee',
    cell: ({ getValue }) => <CurrencyCell value={getValue<string | number>()} />
  },
  {
    header: 'Brand Fee',
    accessorKey: 'brand_fee',
    cell: ({ getValue }) => <CurrencyCell value={getValue<string | number>()} />
  },
  // {
  //   header: 'Amount Due (Credit)',
  //   accessorKey: 'amount_due',
  //   cell: ({ getValue }) => (
  //     <CurrencyCell value={getValue<string|number>()} />
  //   ),
  // },
  // {
  //   header: 'Cumulative Balance',
  //   accessorKey: 'cumulative_balance',
  //   cell: ({ getValue }) => (
  //     <CurrencyCell value={getValue<string|number>()} />
  //   ),
  // },
  {
    header: 'Total ACH',
    accessorKey: 'total_ach',
    cell: ({ getValue }) => <CurrencyCell value={getValue<string | number>()} />
  }
];
